import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private selectedMenuItemSubject = new BehaviorSubject<string>('Home');
  public selectedMenuItem$: Observable<string> =
    this.selectedMenuItemSubject.asObservable();

  private isMenuExpandedSubject = new BehaviorSubject<boolean>(true);
  public isMenuExpanded$: Observable<boolean> =
    this.isMenuExpandedSubject.asObservable();

  constructor() {}

  setSelectedMenuItem(menuItem: string): void {
    this.selectedMenuItemSubject.next(menuItem);
  }

  getCurrentMenuItem(): string {
    return this.selectedMenuItemSubject.value;
  }

  setMenuExpanded(isExpanded: boolean): void {
    this.isMenuExpandedSubject.next(isExpanded);
  }

  getMenuExpandedState(): boolean {
    return this.isMenuExpandedSubject.value;
  }
}
